import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    patientRecentModalities: {},
    patientRecentSerialNumbers: {},
};

const savedModalitiesSlicer = createSlice({
    name: "savedPatientModalities",
    initialState,
    reducers: {
        resetModalitiesState: (state) => {
            Object.assign(state, initialState);
        },
        setSavedPatientModalitiesState: (state, action) => {
            state.patientRecentModalities = action.payload;
        },
        setSavedPatientSerialNumbers: (state, action) => {
            state.patientRecentSerialNumbers = action.payload;
        },
        /** Merge modalities and serial numbers for one or more patients (e.g. after fetching detailed enrollment data). */
        mergeModalitiesAndSerialNumbers: (state, action) => {
            const { modalities = {}, serialNumbers = {} } = action.payload;
            state.patientRecentModalities = { ...state.patientRecentModalities, ...modalities };
            state.patientRecentSerialNumbers = { ...state.patientRecentSerialNumbers, ...serialNumbers };
        },
    }
});

export const { resetSavedPatientModalities, setSavedPatientModalitiesState, setSavedPatientSerialNumbers, mergeModalitiesAndSerialNumbers } = savedModalitiesSlicer.actions;
  
  export default savedModalitiesSlicer.reducer;